import { ALBUM_SORTINGS } from "./constants/enumConstants";
import { RANDOM_METHODS } from "./constants/userSettingsConstants";
import { sortSavedAlbums } from "./spotifyUtils";
import { randomIntFromInterval } from "./utils";

// #region Algorithms

const simpleMethod = (recentAlbums) => {
    const randomIndex = randomIntFromInterval(1, recentAlbums.length - 1);
    return recentAlbums[randomIndex];
}

const albumBlocksMethod = (recentAlbums) => {
    const getAlbumBlocks = () => {
        const getNewAlbumBlock = (albumBlocks, limitEnd) =>
        {
            const limitStart = albumBlocks.length > 0 ? albumBlocks[albumBlocks.length - 1].limitEnd + 1 : 1;
            const newAlbumBlock = {
                limitStart,
                limitEnd : limitEnd
            };
    
            return newAlbumBlock;
        }

        const possibleNextAlbumsLenght = recentAlbums.length - 1;
        const initialAlbumBlockLenght = Math.floor(possibleNextAlbumsLenght / 2);
        const minBlockLength = 2;
        let albumBlocks = [];

        let i = 1;
        let currentAlbumBlockLenght = initialAlbumBlockLenght;
        while(i < possibleNextAlbumsLenght)
        {
            if(i + currentAlbumBlockLenght > possibleNextAlbumsLenght)
            {
                albumBlocks = [...albumBlocks, getNewAlbumBlock(albumBlocks, possibleNextAlbumsLenght)];
                break;
            }

            albumBlocks = [...albumBlocks, getNewAlbumBlock(albumBlocks, i + currentAlbumBlockLenght)];
            i += currentAlbumBlockLenght;
            currentAlbumBlockLenght = Math.floor(currentAlbumBlockLenght / 2);
            if(currentAlbumBlockLenght < minBlockLength)
            {
                currentAlbumBlockLenght = minBlockLength;
            }
        }

        return albumBlocks;
    }

    const albumBlocks = getAlbumBlocks();
    
    const randomBlockIndex = randomIntFromInterval(0, albumBlocks.length - 1);

    const randomBlock = albumBlocks[randomBlockIndex];

    const randomIndex = randomIntFromInterval(randomBlock.limitStart, randomBlock.limitEnd);

    return recentAlbums[randomIndex];
}

const avoidAlbumAlreadyInQueue = (randomAlbum, recentAlbums, comingFromRight = undefined) => {
    if(!randomAlbum.inQueue)
    {
        return randomAlbum;
    }

    // We get the playedRecently index of the currently selected album, which is the current sort index of the recentAlbums array
    const albumIndex = randomAlbum.sortIndexes.playedRecently;

    // If the index points to the second album of the recentAlbums array
    // (we don't consider the first one since we don't want to never played the last played album)
    if(albumIndex === 1)
    {
        // Then, we will check if the next album, the third one, is not in queue
        return avoidAlbumAlreadyInQueue(recentAlbums[2], recentAlbums, false);
    }

    // If the the index points to the last album of the recentAlbums array
    if(albumIndex === recentAlbums.length - 1)
    {
        // Then, we will check if the previous album, the penultimate one, is not in queue
        return avoidAlbumAlreadyInQueue(recentAlbums[recentAlbums.length - 2], recentAlbums, true);
    }

    // If it is known that this is not the first iteration and, then, we are coming from the previous or the next album
    if(comingFromRight !== undefined)
    {
        // If we are coming from the right album
        if(comingFromRight)
        {
            // We force to check the previous album, since we already know that the next album (the right one) is in queue
            return avoidAlbumAlreadyInQueue(recentAlbums[albumIndex - 1], recentAlbums, comingFromRight);
        }

        // Otherwise, we are coming from the previous/left album, so we force to check the next/right album
        return avoidAlbumAlreadyInQueue(recentAlbums[albumIndex + 1], recentAlbums, comingFromRight);
    }

    // In any other case, it is chosen randomized if we check the previous or the next album to the currently selected album
    const chooseRightAlbum = randomIntFromInterval(0, 1);

    if(chooseRightAlbum)
    {
        // We check the next one
        return avoidAlbumAlreadyInQueue(recentAlbums[albumIndex + 1], recentAlbums, false);
    }

    // Or we check the previous one
    return avoidAlbumAlreadyInQueue(recentAlbums[albumIndex - 1], recentAlbums, true);
}

// #endregion Algorithms

export const getNewRandomAlbum = (albums, randomMethod, sortAlbums = false) => {
    if(!albums || albums.length === 0)
    {
        return undefined;
    }

    let recentAlbums = albums;
    if(sortAlbums)
    {
        recentAlbums = sortSavedAlbums(albums, ALBUM_SORTINGS.playedRecently);
    }

    let randomAlbum = undefined;

    if(randomMethod === RANDOM_METHODS.albumBlocks)
    {
        randomAlbum = albumBlocksMethod(recentAlbums);
    }
    else
    {
        randomAlbum = simpleMethod(recentAlbums);
    }

    randomAlbum = avoidAlbumAlreadyInQueue(randomAlbum, recentAlbums);

    return randomAlbum;

}